import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../services/redux/hooks/use-dispatch";
import { useDialogSelections } from "../../../hooks/use-dialog-selections";
import { useStorageSelectors } from "../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import {
  selectDialogValue,
  selectIsMessageLoading,
} from "../../../redux/selectors";
import { useInitAssistantOptions } from "../../../../../common/Components/Selects/hooks/use-init-assistants-options";
import { setDialogSelectedAssistant } from "../../../redux/slice";
import { AssistantSelect } from "../../../../../common/Components/Selects/Components/AssistantSelect";
import { ModelsSelect } from "../../../../../common/Components/Selects/Components/ModelSelects";

export const DialogSelections = () => {
  const dispatch = useAppDispatch();
  const { handleSelectAssistant, handleSelectModel } = useDialogSelections();
  const { selectedId } = useStorageSelectors("dialogs");
  const value = useAppSelector(selectDialogValue);
  const { assistants } = useInitAssistantOptions();
  const isMessageLoading = useAppSelector(selectIsMessageLoading);
  const { t } = useTranslation();

  const selectedAssist = useMemo(() => {
    if (!value?.dialog_object?.assistant_ref) return null;
    const currentAssistant =
      assistants
        .filter(
          (item) =>
            item?.value?.assistant_object?.metadata?.dialogs === "false",
        )
        .find((assist) => assist.ref === value.dialog_object!.assistant_ref) ||
      null;
    return currentAssistant;
  }, [assistants, value?.dialog_object?.assistant_ref]);

  useEffect(() => {
    if (selectedAssist !== undefined) {
      dispatch(setDialogSelectedAssistant(selectedAssist));
    }
  }, [selectedAssist, dispatch]);

  if (!selectedId) return null;

  return (
    <>
      <AssistantSelect
        assistants={
          assistants.filter(
            (item) =>
              item?.value?.assistant_object?.metadata?.dialogs === "false",
          ) || []
        }
        assistant={selectedAssist}
        onSelectAssistant={handleSelectAssistant}
        isDisabled={isMessageLoading}
        emptyOptionLabel={t("app_selects.without_assistant")}
      />
      {selectedAssist === null && (
        <ModelsSelect
          modelId={value?.dialog_object?.model ?? null}
          updateObject={handleSelectModel}
          isDisabled={isMessageLoading}
        />
      )}
    </>
  );
};
